<template>
  <v-autocomplete
    v-model="myBroker"
    :autofocus="autofocus"
    :items="items"
    :disabled="disabled"
    :loading="isLoading"
    :label="$t(`views.stocks.stockModal.broker`)"
    :placeholder="
      multiCurrency
        ? $t(`views.stocks.stockModal.selectBrokerMulticurrency`)
        : $t(`views.stocks.stockModal.selectBroker`)
    "
    hide-no-data
    hide-details
    @change="$emit('change', myBroker)"
  ></v-autocomplete>
</template>

<script>
import { getBrokers } from '@/lib/api.js'
import { isValidObjectId } from '@/lib/utils/mongooseUtils.js'

export default {
  props: {
    value: {
      type: null,
      default: () => {},
    },
    autofocus: {
      type: Boolean,
      default: false,
    },
    disabled: {
      type: Boolean,
      default: false,
    },
    multiCurrency: {
      type: Boolean,
      default: false,
    },
    notSelectFirst: {
      type: Boolean,
      default: false,
    },
  },
  data: () => ({
    myBroker: null,
    entries: [],
    isLoading: false,
    search: null,
  }),
  computed: {
    items() {
      return this.entries.map((entry) => {
        return {
          text: entry.alias,
          value: entry,
        }
      })
    },
  },
  watch: {
    myBroker: {
      handler() {
        if (!this.myBroker) return
        if (JSON.stringify(this.myBroker) === JSON.stringify(this.value)) return
        this.$emit('input', this.myBroker)
      },
      deep: true,
    },
    value: {
      async handler() {
        if (!this.value) return

        // si me llega un id en value, pido brokers y busco el broker.
        if (typeof this.value === 'string' && isValidObjectId(this.value)) {
          if (!this.entries.length) await this.loadBrokers()
          const tmpValue = this.value
          this.myBroker = this.entries.find((elem) => {
            return elem._id === tmpValue
          })
        } else {
          this.myBroker = JSON.parse(JSON.stringify(this.value))
        }

        if (this.items.length === 1) this.selectFirst()
      },
      immediate: true,
    },
    items: {
      handler() {
        this.$emit('update:brokers', this.items)
        if (this.items.length === 1) this.selectFirst()
      },
      immediate: true,
    },
    isLoading: {
      handler() {
        this.$emit('update:isLoading', this.isLoading)
      },
      immediate: true,
    },
    multiCurrency() {
      this.loadBrokers()
    },
  },
  async created() {
    await this.loadBrokers()
  },
  methods: {
    selectFirst() {
      if (!this.notSelectFirst) this.$set(this, 'myBroker', this.items[0].value)
    },
    async loadBrokers() {
      this.isLoading = true
      try {
        const brokers = await getBrokers()
        if (this.multiCurrency) {
          brokers.data = brokers.data.filter((broker) => !!broker.multiCurrency)
        }
        this.entries = brokers.data
      } catch (error) {
        this.$root.$snackbar.checkAndOpenCommonLoadError(error)
      }
      this.isLoading = false
    },
  },
}
</script>
